module.exports = __webpack_public_path__ + "static/media/Node.js_logo.0bec6938.png";